var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass:
        "navbar navbar-expand-lg navbar-expand-sm navbar-expand navbar-light bg-light mt-1 mb-1",
    },
    [
      _c(
        "a",
        { staticClass: "navbar-brand", attrs: { href: _vm.item.alias } },
        [_vm._v("\n        " + _vm._s(_vm.item.title) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse navbar-collapse",
          attrs: { id: "navbarTogglerDemo03" },
        },
        [
          _c("ul", { staticClass: "navbar-nav mr-auto mt-0 mt-lg-0" }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "width-3 height-2 d-inline-flex align-items-center justify-content-center position-relative h1 mr-1 mb-0",
              attrs: { href: _vm.item.alias },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "badge badge-icon pos-top pos-right" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.animatedNumber) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack fs-xxl" }, [
      _c("i", {
        staticClass: "base base-9 icon-stack-3x opacity-100 color-primary-300",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fal fa-digging icon-stack-1x opacity-100 color-white",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }